<template>
  <v-container fluid>
  <div class="d-flex justify-end mb-4">
    <v-btn color="primary" @click="cargarGaleria" prepend-icon="mdi-reload">
      Recargar Widgets
    </v-btn>
  </div>
    <v-row>
      <!-- VISITAS -->
      <v-col cols="12" md="6">
        <v-card class="pa-4">
          <h2 class="text-h5 mb-2">VISITAS POR DÍA</h2>
          <canvas ref="chartCanvas"></canvas>
        </v-card>
      </v-col>
 
      <!-- VISITAS POR HORA Y DÍA -->
      <v-col cols="12" md="6">
        <v-card class="pa-4">
          <h2 class="text-h5 mb-2">VISITAS POR HORA (AGRUPADAS POR FECHA)</h2>
          <canvas ref="hourChart"></canvas>
        </v-card>
      </v-col>
      <!-- DISPOSITIVOS -->
      <v-col cols="12" md="3">
        <v-card class="pa-4">
          <h2 class="text-h5 mb-2">DISPOSITIVOS</h2>
          <canvas ref="deviceChart"></canvas>
        </v-card>
      </v-col>

      <!-- NAVEGADORES -->
      <v-col cols="12" md="3">
        <v-card class="pa-4">
          <h2 class="text-h5 mb-2">NAVEGADORES</h2>
          <canvas ref="browserChart"></canvas>
        </v-card>
      </v-col>

      <!-- SISTEMA OPERATIVO -->
      <v-col cols="12" md="3">
        <v-card class="pa-4">
          <h2 class="text-h5 mb-2">SISTEMA OPERATIVO</h2>
          <canvas ref="osChart"></canvas>
        </v-card>
      </v-col>


      <!-- REFERENCIAS -->
      <v-col cols="12" md="3">
        <v-card class="pa-4">
          <h2 class="text-h5 mb-2">REFERERS</h2>
          <canvas ref="refererChart"></canvas>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card class="pa-4 d-flex flex-column align-center justify-center text-center">
          <h3 class="text-subtitle-1">Total Horas (último día)</h3>
          <span class="text-h4 font-weight-bold text-primary">{{ totalHorasDia }}h</span>
          <h3 class="text-subtitle-1">Última visita</h3>
          <v-chip color="green" text-color="white" class="mt-2">{{ ultima_visita }}</v-chip>
        </v-card>
      </v-col>
      
      <!-- Widget 3: Estado del sistema -->
      <v-col cols="12" md="3">
        <v-card class="pa-4 d-flex flex-column align-center justify-center text-center">

      <h3 class="text-subtitle-1">Día con más visitas</h3>
      <span class="text-h4 font-weight-bold text-primary">{{ diaTop }} ({{ diasVisitas }})</span>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import Chart from 'chart.js/auto'
import { useStore } from 'vuex'
defineOptions({
  name: 'DashboardView'
})
const chartCanvas = ref<HTMLCanvasElement | null>(null)
const deviceChart = ref<HTMLCanvasElement | null>(null)
const browserChart = ref<HTMLCanvasElement | null>(null)
const osChart = ref<HTMLCanvasElement | null>(null)
const hourChart = ref<HTMLCanvasElement | null>(null)
const refererChart = ref<HTMLCanvasElement | null>(null)

let chartVisitas: Chart | null = null
let chartDispositivos: Chart | null = null
let chartNavegadores: Chart | null = null
let chartOS: Chart | null = null
let chartHoras: Chart | null = null
let chartReferers: Chart | null = null

const totalHorasDia = ref(0)
const diaTop = ref('')
const diasVisitas = ref(0)
const aColors = ref([
    '#42A5F5', '#66BB6A', '#FFA726', '#AB47BC', '#26A69A',
    '#EC407A', '#FF7043', '#26C6DA', '#8D6E63', '#78909C', 
    '#FFCA28', '#FF8A65', '#7E57C', '#B39DDB', '#90A4AE'
  ])
const ultima_visita = ref('')

interface DashboardItem {
  total: number
  [key: string]: any
}
const dashboard = ref<DashboardItem[]>([])
const responseDashboad = computed(() => store.state.Dashboard.responseDashboad)
const store = useStore()
// let chartInstance: Chart | null = null
async function cargarGaleria() {
  
  // loadSkeleton.value = true
  await store.dispatch('Dashboard/getDashboard') 
  dashboard.value = responseDashboad.value?.data ?? []
  vistasDiarias()
  vistasDispositivos()
  vistasNavegacion()
  vistaOs()
  vistasPorHora()
  vistaReferers()
  calcularTotalHorasUltimoDia()
  calcularDiaMasVisitado()
  cargarUltimaVista()
}

function vistasDiarias() {
  const dataByDay = dashboardLimitado.value; // Use your data object here
  if (chartCanvas.value) {
    if (chartVisitas) {
      chartVisitas.destroy()
    }
    chartVisitas = new Chart(chartCanvas.value, {
      type: 'scatter',
      data: {
        labels: Object.keys(dataByDay),
        datasets: [
          {
            type: 'bar',
            label: 'Visitas totales por día',
            data: Object.values(dataByDay).map(v => v.total ?? 0),
            borderColor: '#08440aff',
            backgroundColor: '#4CAF50'
          },
        ],
      },
    })
  }
}

function vistasDispositivos() {
  const dataByDay = dashboardLimitado.value; // Use your data object here
  const totalDevices: Record<string, number> = {};
  for (const day of Object.values(dataByDay)) {
      for (const [k, v] of Object.entries(day.devices ?? {})) {
          const value = typeof v === 'number' ? v : 0;
          totalDevices[k] = (totalDevices[k] ?? 0) + value;
      }
  }
  if (deviceChart.value) {
    if (chartDispositivos) {
      chartDispositivos.destroy()
    }
    chartDispositivos = new Chart(deviceChart.value, {
      type: 'pie',
      data: {
        labels: Object.keys(totalDevices),
        datasets: [
          {
            label: 'Dispositivos',
            data: Object.values(totalDevices),
            backgroundColor: aColors.value
          },
        ],
      },
    })
  }
}

function vistasNavegacion() {
  const dataByDay = dashboardLimitado.value; // Use your data object here
  const totalBrowsers: Record<string, number> = {};
        for (const day of Object.values(dataByDay)) {
            for (const [k, v] of Object.entries(day.browsers ?? {})) {
                const value = typeof v === 'number' ? v : 0;
                totalBrowsers[k] = (totalBrowsers[k] ?? 0) + value;
            }
        }
  if (browserChart.value) {
    if (chartNavegadores) {
      chartNavegadores.destroy()
    }
    chartNavegadores = new Chart(browserChart.value, {
      type: 'doughnut',
      data: {
        labels: Object.keys(totalBrowsers),
        datasets: [
          {
            label: 'Navegadores',
            data: Object.values(totalBrowsers),
            backgroundColor: aColors.value
          },
        ],
      },
    })
  }
}

function vistaOs() {
  const dataByDay = dashboardLimitado.value; // Use your data object here
  const totalOS: Record<string, number> = {};
  for (const day of Object.values(dataByDay)) {
    for (const [k, v] of Object.entries(day.os ?? {})) {
      const value = typeof v === 'number' ? v : 0;
      totalOS[k] = (totalOS[k] ?? 0) + value;
    }
  }
  if (osChart.value) {
    if (chartOS) {
      chartOS.destroy()
    }
    chartOS = new Chart(osChart.value, {
      type: 'pie',
      data: {
        labels: Object.keys(totalOS),
        datasets: [
          {
            label: 'Sistemas Operativos',
            data: Object.values(totalOS),
            backgroundColor: aColors.value
          },
        ],
      },
    })
  }
}

function vistaReferers() {
  const totalReferers: Record<string, number> = {}
  for (const day of Object.values(dashboardLimitado.value)) {
    for (const [ref, count] of Object.entries(day.referers ?? {})) {
      totalReferers[ref] = (totalReferers[ref] ?? 0) + (count as number)
    }
  }

  if (refererChart.value) {
    if (chartReferers) {
      chartReferers.destroy()
    }
    chartReferers = new Chart(refererChart.value, {
      type: 'doughnut',
      data: {
        labels: Object.keys(totalReferers),
        datasets: [{
          label: 'Referers',
          data: Object.values(totalReferers),
          backgroundColor: aColors.value
        }],
      },
    })
  }
}

function vistasPorHora() {
  const horas = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'))

  const datasets = Object.entries(dashboardLimitado.value).map(([fecha, data], index) => {
    const hourlyData = data.hourly ?? {}
    const valoresPorHora = horas.map(hora => hourlyData[hora] ?? 0)

    return {
      label: fecha,
      data: valoresPorHora,
      backgroundColor: getColor(index),
      stack: 'visitas'
    }
  })

  if (hourChart.value) {
    if (chartHoras) {
      chartHoras.destroy()
    }
    chartHoras = new Chart(hourChart.value, {
      type: 'bar',
      data: {
        labels: horas.map(h => `${h}:00`),
        datasets
      },
      options: {
        responsive: true,
        plugins: {
          tooltip: {
            callbacks: {
              label: (context: any) => {
                const valor = context.raw
                return `${context.dataset.label}: ${valor} visita${valor !== 1 ? 's' : ''}`
              }
            }
          }
        },
        scales: {
          x: {
            stacked: true
          },
          y: {
            stacked: true,
            beginAtZero: true,
            ticks: {
              stepSize: 1
            }
          }
        }
      }
    })
  }
}
function getColor(index: number): string {
  const colores = aColors.value;
  return colores[index % colores.length]
}

function cargarUltimaVista() {
  const fechas = Object.keys(dashboardLimitado.value)
  if (fechas.length === 0) return
  
  const ultimaFecha: any = fechas[fechas.length - 1]
  const dataUltimoDia = dashboardLimitado.value[ultimaFecha]
    ultima_visita.value = dataUltimoDia.last_updated

}

function calcularDiaMasVisitado() {
  const diasSemana: Record<string, number> = {}
  let diasMaximo: any = []

  for (const [fecha, data] of Object.entries(dashboardLimitado.value)) {
    const fechaOriginal = new Date(fecha);
    const fechaMasUnDia = new Date(fechaOriginal);
    fechaMasUnDia.setDate(fechaMasUnDia.getDate() + 1);
    const dia = fechaMasUnDia.toLocaleDateString('co-CO', { weekday: 'long' }) 
    diasSemana[dia] = (diasSemana[dia] ?? 0) + (data.total ?? 0)
    diasMaximo = {...diasSemana}
  } 
  diaTop.value = Object.entries(diasSemana).sort((a, b) => b[1] - a[1])[0]?.[0] ?? ''
  diasVisitas.value =  Math.max(...Object.values(diasMaximo).map(v => Number(v)))
}

function calcularTotalHorasUltimoDia() {
  const fechas = Object.keys(dashboardLimitado.value)
  if (fechas.length === 0) return
  
  const ultimaFecha: any = fechas[fechas.length - 1]
  const dataUltimoDia = dashboardLimitado.value[ultimaFecha]
  const horas = dataUltimoDia?.hourly ?? {}
  const totalHoras = Object.values(horas).reduce((sum: number, val: any) => sum + val, 0);
  totalHorasDia.value = totalHoras
}

const dashboardLimitado = computed(() => {
  const entradas = Object.entries(dashboard.value)
  const ultimos15 = entradas.slice(-7) // obtiene los últimos 15 registros
  return Object.fromEntries(ultimos15)
})

onMounted(() => {
  cargarGaleria();
})
</script>
